import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQS = [
  { question: 'When does beta launch?', answer: "We're targeting September 2026. Beta testers will be notified 2 weeks before launch." },
  { question: 'Is beta testing free?', answer: 'Yes! Beta testers get 3 years free at our £15/month Part-Time tier (worth £540). No credit card required.' },
  { question: 'Is there a community for flippers?', answer: "Absolutely! Flipping can be lonely, so we're building a community where resellers can share strategies, celebrate wins, and learn from each other. Beta testers get exclusive access to our private community." },
  { question: 'What devices will Flipping Friends support?', answer: "iPhone, Android, and web browser. We're building a Progressive Web App (PWA) so it works offline in charity shops with poor signal." },
  { question: 'Which buyers do you check?', answer: "We check the UK's 4 leading media buyers simultaneously, including cash and voucher prices. Specific buyer names are revealed after you join the beta." },
  { question: 'What media types are supported?', answer: "Books, DVDs, CDs, and games. We're starting with these 4 categories and expanding based on beta feedback." },
  { question: 'How does the Equipment Upgrade Programme work?', answer: "Beta testers will get exclusive details, but here's the concept: use your Flipping Friends earnings to upgrade your smartphone and laptop through our equipment partnerships. Full details in the beta welcome email." },
  { question: 'How many beta testers are you accepting?', answer: "We're aiming for 50-100 beta testers to ensure quality feedback. Join the waitlist early to secure your spot." },
];

export default function FAQSection() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <section className="py-24 md:py-32 px-4 sm:px-6 lg:px-8 bg-[#0A0A0A]">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-white mb-12 tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {FAQS.map((faq, index) => (
            <div key={faq.question} className="border border-zinc-800/50 rounded-2xl overflow-hidden hover:border-[#00D26A]/40 transition-colors">
              <button
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
                className="w-full px-6 py-4 text-left bg-[#050505] hover:bg-[#0A0A0A] transition-colors flex justify-between items-center"
                data-testid={`faq-toggle-${index}`}
              >
                <span className="font-semibold text-white">{faq.question}</span>
                <ChevronDown
                  className={`w-5 h-5 text-[#00D26A] transition-transform ${openFaq === index ? 'transform rotate-180' : ''}`}
                />
              </button>
              {openFaq === index && (
                <div className="px-6 py-4 bg-[#0A0A0A]">
                  <p className="text-zinc-400 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
